import { render, staticRenderFns } from "./IntroTextBox.vue?vue&type=template&id=034e0c3e&scoped=true&"
import script from "./IntroTextBox.vue?vue&type=script&lang=js&"
export * from "./IntroTextBox.vue?vue&type=script&lang=js&"
import style0 from "./IntroTextBox.vue?vue&type=style&index=0&id=034e0c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e0c3e",
  null
  
)

export default component.exports